import React from "react";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// COMPONENTS
import FormInputText from "../../../../../components/form/FormInputText";
// INTERFACES
import { ReadSyncItemMessageInterface } from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentReadSyncItemMessage({
	data,
	setData,
}: {
	data: ReadSyncItemMessageInterface;
	setData: (newValue: ReadSyncItemMessageInterface) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const [t] = useTranslation("global");

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */
	const onChangeValue = (newValue: string, variableName: string) => {
		const copy = structuredClone(data);
		if (variableName === "group_name") {
			copy.message.group_name = newValue;
		} else if (variableName === "item_name") {
			copy.message.item_name = newValue;
		}
		setData(copy);
	};

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			<FormInputText
				inputValue={data.message.group_name}
				inputLabelName={t("general.groupName")}
				inputOnChange={onChangeValue}
				inputVariableName='group_name'
				isRequired
				disabledInput={false}
				
			/>
			<FormInputText
				inputValue={data.message.item_name}
				inputLabelName={t("general.itemName")}
				inputOnChange={onChangeValue}
				inputVariableName='item_name'
				isRequired
				disabledInput={false}
				
			/>
		</div>
	);
}
